import Grid from '@mui/material/Grid2';
import { Avatar, Box, Card, Link, Stack, Typography} from '@mui/material';
import ElectedFiler from '../../../types/filers/electedFiler';

interface Props {
    officers?:ElectedFiler[]
 }

const TownElectedOfficials = (props: Props): JSX.Element => {

    return (
    <Box marginTop={3} marginBottom={4}>
        <Box marginBottom={4}>
            <Typography
                variant="h6"
                sx={{
                    textTransform: 'uppercase',
                }}
                fontWeight={700}
                data-aos={'fade-up'}
                gutterBottom
                color={'primary'}
                align={'center'}
            >
                ELECTED OFFICIALS
            </Typography>
        </Box>
        <Grid container spacing={4}>
          {props.officers?.map((filer) => (
            <Grid key={filer.cpfId} size={{xs:12, md:4}}>
              <Card
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: 1,
                  height: 1,
                  background: 'transparent',
                }}
              >
                <Avatar
                  src={filer.filerPhotoUrlThumbnail}
                  variant={'circular'}
                  alt={filer.filerName + " photo"}
                  sx={{
                    width: 120,
                    height: 120,
                  }}
                />
                <Typography marginTop={1} fontWeight={700} color="primary" component={Link} underline='hover' href={`/Filers?q=${filer.cpfId}`}>
                    {filer.cpfId} {filer.filerName}
                </Typography>
                <Typography color={'text.secondary'}>{filer.officeNameHeld}</Typography>
                <Box flexGrow={1} />
                <Stack
                  marginTop={4}
                  width={1}
                  alignItems={'center'}
                >
                    <Typography color={'text.secondary'} variant={'subtitle2'}>
                      {filer.partyAffiliation}
                    </Typography>
                    <Typography color={'text.secondary'} variant={'subtitle2'}>
                        <Link href={`/reports/displayreport?id=${filer.bankReportId}`} underline='hover' target="_blank">{filer.currentCashOnHand}</Link> Cash On Hand
                    </Typography>
                    <Typography color={'text.secondary'} variant={'subtitle2'}>
                        {filer.candidateFullAddress}
                    </Typography>
                </Stack>
              </Card>
            </Grid>
          ))}
        </Grid>
    </Box>
    )

}

export default TownElectedOfficials;